import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=1e416d04&"
import script from "./DocList.vue?vue&type=script&lang=js&"
export * from "./DocList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports